import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';

/**
 * The list of tabs on this page
 */
export enum ExperienceAIAdvisorPageTabId {
	Accelerator = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum ExperienceAIAdvisorPageViewId {
	PromptResponse = 1,
	PromptError = 2,
}


@Injectable({ providedIn: 'root' })
export class ExperienceAIAdvisorService extends PageTabsLayoutPageService<ExperienceAIAdvisorPageTabId, ExperienceAIAdvisorPageViewId> {

	private static readonly _viewDroplistItems: DroplistItem<never, ExperienceAIAdvisorPageViewId>[] = [
		{
			uniqueId: ExperienceAIAdvisorPageViewId.PromptResponse,
			iconContext: {
				iconClass: 'fa-comments-question-check',
				iconStyle: 'fa-solid',
				text: 'Prompts And Responses',
				hideText: 'never',
			},
			customSort: '1-Responses'
		},
		{
			uniqueId: ExperienceAIAdvisorPageViewId.PromptError,
			iconContext: {
				iconClass: 'fa-comment-xmark',
				iconStyle: 'fa-solid',
				text: 'Prompt Errors',
				hideText: 'never',
			},
			customSort: '2-Errors'
		}
	];

	constructor() {
		super(ExperienceAIAdvisorService._viewDroplistItems, ExperienceAIAdvisorService.name, ExperienceAIAdvisorPageTabId.Accelerator, ExperienceAIAdvisorPageViewId.PromptResponse);
	}

	public get viewId() {
		return ExperienceAIAdvisorPageViewId;
	}

}